function createElement(tag, id = '', classList = [], styles = {}, text = '') {
    const element = document.createElement(tag);
    if (id) {
        element.id = id;
    }

    if (classList.length > 0) {
        classList.forEach(className => {
            element.classList.add(className);
        });
    }

    if (Object.keys(styles).length > 0) {
        Object.keys(styles).forEach(style => {
            element.style[style] = styles[style];
        });
    }

    if (text) {
        element.innerText = text;
    }

    return element;
}

export default createElement;